















import { defineComponent } from '@nuxtjs/composition-api';
import BaseHeading from '@shared/components/@atoms/BaseHeading/BaseHeading.vue';
export default defineComponent({
  name: 'BaseSection',
  components: {
    BaseHeading,
  },
  props: {
    titleHeading: {
      type: String,
      default: '',
    },
    subtitleHeading: {
      type: String,
      default: '',
    },
    levelHeading: {
      type: Number,
      default: 2,
    },
  },
});
